import { defineMessages } from '@jutro/locale';

export default defineMessages({
      additionalCarriersQuoted: {
        id: 'ml.gateway.views.AdditionalCarrierPopup.additionalCarriersQuoted',
        defaultMessage: 'Additional Carrier(s) Quoted'
    },
    partnerCarriersSelect: {
        id: 'ml.gateway.views.AdditionalCarrierPopup.partnerCarriersSelect',
        defaultMessage: 'Select all that apply:'
    },
    additionalCarriersBound: {
        id: 'ml.gateway.views.AdditionalCarrierPopup.additionalCarriersBound',
        defaultMessage: 'Additional Carrier(s) Bound'
    },
    boundSelect: {
        id: 'ml.gateway.views.AdditionalCarrierPopup.boundSelect',
        defaultMessage: 'Bound application with:'
    },
    save: {
        id: 'ml.gateway.views.AdditionalCarrierPopup.save',
        defaultMessage: 'RETURN'
    },
    noChangesNeeded: {
        id: 'ml.gateway.views.AdditionalCarrierPopup.NO CHANGES noChangesNeeded',
        defaultMessage: 'NO CHANGES NEEDED'
    }

})